import { hoursAgo, hoursBetween } from '../operationalIntelligence/intelligenceHeuristics';

export const COORD_SPILLOVER_STALL_HOURS = 3;
export const COORD_VEHICLE_OVER_PLAN_HOURS = 2;
export const COORD_MIN_TRANSITION_HOURS = 4;
export const COORD_DRIVER_OVERTIME_HOURS = 4;

export { hoursAgo, hoursBetween };

export function severityRank(s: string): number {
  return { LOW: 1, MEDIUM: 2, HIGH: 3, CRITICAL: 4 }[s] ?? 0;
}

export function maxSeverity(severities: Array<string | null | undefined>): import('./types').ImpactSeverity | null {
  let best: import('./types').ImpactSeverity | null = null;
  for (const s of severities) {
    if (!s) continue;
    if (!best || severityRank(s) > severityRank(best)) best = s as import('./types').ImpactSeverity;
  }
  return best;
}

export function parseDay(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function periodEnd(plannedUnloading: string | null, lastStopPlanned: string | null): Date | null {
  return parseDay(plannedUnloading) ?? parseDay(lastStopPlanned);
}

export function periodStart(plannedLoading: string | null, firstStopPlanned: string | null): Date | null {
  return parseDay(plannedLoading) ?? parseDay(firstStopPlanned);
}

export function estimateSpilloverHours(params: {
  intelligence: import('../operationalIntelligence/types').RouteOperationalIntelligence | null;
  plannedUnloadingDate: string | null | undefined;
  now: Date;
}): number {
  const { intelligence, plannedUnloadingDate, now } = params;
  let hours = 0;

  if (plannedUnloadingDate) {
    const overdue = hoursAgo(plannedUnloadingDate, now);
    if (overdue != null && overdue > 0) hours = Math.max(hours, Math.min(overdue, 24));
  }

  if (intelligence?.progression.isStalled) {
    const inactive = intelligence.progression.hoursSinceLastActivity;
    hours = Math.max(hours, inactive ?? COORD_SPILLOVER_STALL_HOURS, COORD_SPILLOVER_STALL_HOURS);
  } else if (intelligence?.health.state === 'DELAYED' || intelligence?.health.state === 'STALLED') {
    hours = Math.max(hours, COORD_SPILLOVER_STALL_HOURS);
  }

  if (intelligence?.health.state === 'CRITICAL') {
    hours = Math.max(hours, 6);
  }

  return hours > 0 ? Math.round(hours * 10) / 10 : 0;
}
